import axios from 'axios'
import router from './router'

let axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

axiosInstance.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  if (error && error.response.data === 'login-expired') {
    console.log("Login Expired")
    router.push({
      name: 'login',
      params: {
        timeout: true
      }
    });
    return Promise.reject('Session Timeout: Login again to continue. If you navigate away from this page you will lose any unsaved work!')
  }
  return Promise.reject(error);
});

export default axiosInstance
